import { t } from 'i18next';
import { CSSProperties, ReactNode } from 'react';
import { IChildrenProp } from 'types/components/components.interface';
import './PublicPageTemplate.scss';

interface IPublicPageTemplateProps extends IChildrenProp {
  header?: ReactNode;
  footer?: ReactNode;
  creative?: ReactNode;
  wrapperContentStyle?: CSSProperties;
  withConsent?: boolean;
}

const PublicPageTemplate = ({
  header,
  children,
  creative,
  footer,
  withConsent = true,
  wrapperContentStyle,
}: IPublicPageTemplateProps) => {
  return (
    <div className='public-page-wrapper'>
      <div
        className={`public-page-template ${creative ? 'with-creative' : ''}`}>
        {creative && <div className='creative'>{creative}</div>}
        {(header || children || footer) && (
          <div style={wrapperContentStyle} className='public-page'>
            <div className='header'>{header}</div>
            <div className='content'>{children}</div>
            <div className='footer'>{footer}</div>
          </div>
        )}
      </div>
      {withConsent && (
        <div className='public-page-consent'>
          <a
            href='https://magellanevafyeko.blob.core.windows.net/magellan/documents/MagelUp_Polityka%20prywatno%C5%9Bci_15%2007%202020_KR.pdf'
            target='_blank'>
            {t('public-page.privacy-policy')}
          </a>
          <span />
          <a
            href='https://magellanevafyeko.blob.core.windows.net/magellan/documents/MagelUp_Regulamin%20KR_17.07.2023.pdf'
            target='_blank'>
            {t('public-page.regulations')}
          </a>
          <span />
          <a
            href='https://magellanevafyeko.blob.core.windows.net/magellan/documents/MagelUp_Zgody%20+%20klauzula%20informacyjna_15%2007%202020_KR.pdf'
            target='_blank'>
            {t('public-page.clause')}
          </a>
        </div>
      )}
    </div>
  );
};

export default PublicPageTemplate;
